import { Table } from "@mantine/core";
import { Exclusion } from "../models";
import _ from "lodash";
import { Chess } from "chess.js";
import { useForceUpdate } from "@mantine/hooks";

interface Props {
    exclusionsByFen: Record<string, Exclusion[]>;
    game: Chess;
    onLoadFen: (fen: string) => void;
}

const ExclusionsTable: React.FC<Props> = ({ exclusionsByFen, game, onLoadFen }) => {
    const rows = _.keys(exclusionsByFen).map((move) => {
        const value = exclusionsByFen[move];
        const fen = value[0].fen;
        const moveNumber = fen.split(" ")[5];
        const numExclusions = value.length;

        return (
            <Table.Tr
                key={fen}
                className="hover:bg-[var(--mantine-color-blue-light)] hover:cursor-pointer"
                onClick={() => {
                    onLoadFen(fen);
                }}
            >
                <Table.Td>
                    At move {moveNumber}: {numExclusions} exclusions
                </Table.Td>
            </Table.Tr>
        );
    });

    return (
        <Table>
            <Table.Thead>
                {/* <Table.Tr>
                        <Table.Th />
                        <Table.Th>Element position</Table.Th>
                        <Table.Th>Element name</Table.Th>
                        <Table.Th>Symbol</Table.Th>
                        <Table.Th>Atomic mass</Table.Th>
                    </Table.Tr> */}
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    );
};

export default ExclusionsTable;
